import _ from 'lodash'
import React, {Ref} from 'react'
import BottomScrollListener from 'react-bottom-scroll-listener'
import {appendAuctions, fetchAuctions, fetchAuctionsByIds, SubjectType} from 'redux/actions'
import LoadingIndicator from '../../components/LoadingIndicator'
import MissingData from '../../components/MissingData'
import AppNavigation from '../AppNavigation'
import AuctionCard from './AuctionCard'
import {AuctionsState} from '../../redux/reducers/AuctionReducer'
import {GlobalState} from '../../state'
import {connect} from 'react-redux'
import AuctionListEntry from './AuctionListEntry'
import {Panel} from '../../components/Panel'
import SwitchAuctionView from './SwitchAuctionView'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {faBolt, faCalendar, faFire, faGasPump, faTachometerAlt} from '@fortawesome/free-solid-svg-icons'
import {match} from 'react-router'
import {AuctionSettings} from '../../domain-models'
import AlertWarning from '../../components/Alerts/AlertWarning'
import Trans from '../../components/Trans'

type AuctionsProps = {
  auctionsState: AuctionsState
  auction_view: 'list' | 'grid'
  auctionId?: number | null | string
  settings: AuctionSettings
  subjectType: SubjectType
}

class Auctions extends React.Component<AuctionsProps> {
  componentDidMount = async () => {
    if (this.props.auctionId) {
      return await fetchAuctionsByIds([this.props.auctionId], this.props.subjectType)
    }

    if (!this.props.auctionsState.loading) {
      await fetchAuctions(this.props.auctionsState.filter, this.props.subjectType)
    }
    
    // Listen for auction refresh events (triggered by StartedAuctions websocket event)
    window.addEventListener('auctions-refresh', this.handleAuctionsRefresh)
  }
  
  componentWillUnmount() {
    window.removeEventListener('auctions-refresh', this.handleAuctionsRefresh)
  }
  
  handleAuctionsRefresh = async () => {
    await fetchAuctions(this.props.auctionsState.filter, this.props.subjectType)
  }

  appendAuctions = async () => {
    if (this.props.auctionsState.next_page_url) {
      await appendAuctions(this.props.auctionsState.auctions, this.props.auctionsState.next_page_url, this.props.auctionsState.filter, this.props.subjectType)
    }
  }

  componentDidUpdate(prevProps: Readonly<AuctionsProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.subjectType !== this.props.subjectType) {
      fetchAuctions(this.props.auctionsState.filter, this.props.subjectType)
    }
  }

  render() {
    return (
      <BottomScrollListener onBottom={this.appendAuctions}>
        {(scrollRef: Ref<HTMLDivElement>) => (
          <div className='block md:flex overflow-x-auto overflow-y-scroll scrolling-smooth scrolling-touch h-full' ref={scrollRef}>
            <div className='hidden lg:block'>
              <AppNavigation />
            </div>
            <div className='w-full flex flex-col'>
              {this.props.settings.notes ? <AlertWarning>{this.props.settings.notes}</AlertWarning> : null}

              {
                this.props.auctionsState.loading && (!this.props.auctionsState || !this.props.auctionsState.auctions.length) ?
                  <LoadingIndicator />
                  :
                  this.props.auction_view === 'grid' && this.props.auctionsState && this.props.auctionsState.auctions && this.props.auctionsState.auctions.length
                    ?
                    <div className={'flex flex-col'}>
                      <div className={'pt-6 pl-8 font-semibold'}>
                        <SwitchAuctionView />
                      </div>

                      <div className='flex flex-col md:flex-row flex-wrap w-full mt-0'>
                        {
                          _.map(this.props.auctionsState.auctions, auction => {
                            return (<AuctionCard auction={auction} key={auction.Id} />)
                          })
                        }
                      </div>

                      {
                        this.props.auctionsState.loading ?
                          <LoadingIndicator />
                          : null
                      }
                    </div>
                    : this.props.auctionsState && this.props.auctionsState.auctions && this.props.auctionsState.auctions.length ?
                      <Panel classNames={'pr-10 md:pl-2'} overflow={' none '}>
                        <table className={'table-auto my-2 mx-4 text-gray-800 w-full'}>
                          <thead>
                            <tr>
                              <td className={'p-2 font-semibold'}>
                                <SwitchAuctionView />
                              </td>
                              <td className={'p-2 font-semibold'}><Trans>Endet in</Trans></td>
                              <td className={'p-2 font-semibold'}><Trans>Marke</Trans></td>
                              <td className={'p-2 font-semibold'}><Trans>Modell</Trans></td>
                              <td className={'p-2 font-semibold'}><Trans>Standort</Trans></td>
                              <td className={'p-2 font-semibold'}><Trans>Preis</Trans></td>
                              {
                                this.props.subjectType === 'Vehicle' ?
                                  <>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon={faTachometerAlt} /></td>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon={faCalendar} /></td>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon={faFire} /></td>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon={faBolt} /></td>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon={faGasPump} /></td>
                                    <td className={'p-2 font-semibold'}>
                                      <Icon className='text-gray-600 font-normal fa-fw' icon='search-dollar' /></td>
                                    <td className={'p-2 font-semibold'}><Trans>Aktionen</Trans></td>
                                  </>
                                  : null
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {
                              _.map(this.props.auctionsState.auctions, auction => {
                                return (
                                  <AuctionListEntry auction={auction} key={auction.Id} />
                                )
                              })
                            }
                          </tbody>
                        </table>

                        {this.props.auctionsState.loading ?
                          <LoadingIndicator />
                          : null}
                      </Panel>
                      : null
              }

              {
                !this.props.auctionsState.loading && (!this.props.auctionsState || !this.props.auctionsState.auctions || !this.props.auctionsState.auctions.length) ?
                  <MissingData />
                  : null
              }
            </div>
          </div>
        )}
      </BottomScrollListener>
    )
  }
}

type CustomProps = {
  match?: match<{
    auctionId: string | undefined
  }>
} | undefined

export default connect((state: GlobalState, props: CustomProps) => {
  return {
    auctionId: props && props.match ? props.match.params.auctionId : null,
    auctionsState: state.auctions,
    auction_view: state.user.app_settings && state.user.app_settings.auction_view ? state.user.app_settings.auction_view : 'grid',
    settings: state.app.settings,
    subjectType: state.app.subjectType
  }
})(Auctions)
